import { AxiosResponse } from "axios";
import useQueryAction from "../../../lib/useQueryAction";
import useQueryMutation from "../../../lib/useQueryMutation";
import {
  api,
  makeGetRequest,
  makePatchRequest,
  makePostRequest,
} from "../../api";

export type BankType = {
  code: string;
  created_at: string;
  deleted_at: string;
  embeds: string[];
  id: string;
  is_trashed: boolean;
  is_visible: boolean;
  name: string;
  type: string;
  updated_at: string;
};

export type ResolveBankType = {
  account_name: string;
  account_number: string;
  allow_setting_name: boolean;
  phone: boolean;
  session_id: string;
  query_response_code: string;
  destination_bank_code: string;
  bank: { data: BankType };
  id: string;
  code: string;
  name: string;
  type: string;
  is_visible: boolean;
  is_trashed: boolean;
  deleted_at: boolean;
  created_at: string;
  updated_at: string;
};

export const useBanks = () => {
  return useQueryAction({
    queryFn: (): Promise<AxiosResponse<BankType[]>> =>
      makeGetRequest(api.metadata.banks),
    queryKey: ["banks"],
  });
};

export const useBankList = () => {
  return useQueryAction({
    queryFn: () => makeGetRequest(api.admin.BankList),
    queryKey: ["anc_banks"],
  });
};

export const useResolveBankName = () => {
  return useQueryMutation({
    mutationFn: (data: {
      nuban: string;
      bankId: string;
    }): Promise<AxiosResponse<ResolveBankType>> =>
      makePostRequest(data, api.metadata.resolveBankName),
    // queryKey: [" BankName "]
  });
};

export const useUpdateFunctionality = (userId: string) => {
  return useQueryMutation({
    mutationFn: (data): Promise<AxiosResponse<ResolveBankType>> =>
      makePatchRequest(data, api.admin.individualFunctionality(userId)),
  });
};

// export const useRates = ()=>{
//   return useQueryAction({
//      queryFn: ()=> makeGetRequest(api.metadata.rates),
//      queryKey: ['rates']
//   })
// }

export const useSwiftCountries = () => {
  return useQueryAction({
    queryFn: () => makeGetRequest(api.tags.swiftCountries),
    queryKey: ["swift"],
  });
};

export const useIbanCountries = () => {
  return useQueryAction({
    queryFn: () => makeGetRequest(api.tags.ibanCountries),
    queryKey: ["iban"],
  });
};

export const useAbaCountries = () => {
  return useQueryAction({
    queryFn: () => makeGetRequest(api.tags.abaCountries),
    queryKey: ["aba"],
  });
};

export const useAbaDistricts = () => {
  return useQueryAction({
    queryFn: () => makeGetRequest(api.tags.abaDistricts),
    queryKey: ["abaDistricts"],
  });
};
